module.exports = __webpack_public_path__ + "img/personal-team-report.730f350e.svg";